import { Controller } from "@hotwired/stimulus"

// Multi-select V2 (details/summary) que se aplica solo (estilo Grafana):
// marcar/desmarcar una opción ensucia el form del ancestro; cuando el
// <details> se cierra (click fuera, Esc o summary — evento toggle nativo)
// el form se envía. Sin botón Aplicar.
//
// Vive en el <details> del MultiSelectComponent; el form se busca con
// closest(). Suelto (sin form) es inerte.
export default class extends Controller {
  markDirty() {
    this.dirty = true
  }

  submitIfDirty(event) {
    if (event.newState !== "closed" || !this.dirty) return

    this.dirty = false
    this.element.closest("form")?.requestSubmit()
  }

  // Filtros sueltos del mismo form (p. ej. el checkbox "solo huérfanos"):
  // cambio inmediato, sin cierre de dropdown que disparar.
  submit() {
    this.element.closest("form")?.requestSubmit()
  }
}
